@for (notification of notificationService.notifications | async; track notification) {
  <div class="notification">
    <div class="notification-content">
      <div class="notification-progress" [class.error]="notification.status === 'error'" [class.warning]="notification.status === 'warning'"></div>
      <h3 class="notification-heading"
      [class.error]="notification.status === 'error'" [class.warning]="notification.status === 'warning'">{{notification.title}}</h3>
      <p class="notification-content">
        {{notification.text}}
      </p>
    </div>
  </div>
}
